// extracted by mini-css-extract-plugin
export default {"icon":"CustomerTemplate_icon__3J4t1"};